import { render, staticRenderFns } from "./OrderItemNew.vue?vue&type=template&id=3a36d1b7"
import script from "./OrderItemNew.vue?vue&type=script&lang=ts"
export * from "./OrderItemNew.vue?vue&type=script&lang=ts"
import style0 from "./OrderItemNew.vue?vue&type=style&index=0&id=3a36d1b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports